<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="ack"> </p>
<p class="BM-Head-bmh"><span epub:type="pagebreak" id="pg_191" title="191"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><span class="ePub-B">Acknowledgments</span></span></span></p>
<p class="BM-Text-No-Indent-bmtx1">I want to thank Grace Lavery and Christian Brown for answering an unending barrage of text messages asking for their opinions on every change, no matter how minor, I made to this manuscript, like two extremely tolerant optometry patients—“Is this one better? Or is <span class="ePub-I">this</span> one better?” There are no two people whose literary judgment I prize more, and this book has been immeasurably improved thanks to their thoughtful criticism.</p>
<p class="BM-Text-bmtx">Thanks are also due to my editor, Libby Burton, whose careful attention to detail at every stage of the publishing process has been a great relief and a help to me. I am especially grateful to my longtime agent, Kate McKean, who has only ever praised my successes, corrected my errors, and made me money. I wish everyone in the world were like her.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?388fffee